import gql from "graphql-tag";

export const GET_CONTACT_ACCOUNT_POSITION = gql`
    query ContactAccountPosition($contactAccountPositionId: ID!){
        contactAccountPosition(contactAccountPositionId: $contactAccountPositionId) {
            contactAccountPositionId
            contactId
            accountId
            userId
            location
            title
            startDate
            endDate
            current
            lastConfirmedAt
            positionDescription
            createdAt
            updatedAt
            deleted
            deletedAt
            account {
                accountId
                accountName
            }
        }
    }
`;

export const GET_CONTACT_ACCOUNT_POSITIONS = gql`
    query ContactAccountPositions($contactId: ID!, $searchStr: String, $limit: Int, $offset: Int, $showDeleted: Boolean, $orderList: [String]){
        contactAccountPositions(contactId: $contactId, searchStr: $searchStr, limit: $limit, offset: $offset, showDeleted: $showDeleted, orderList: $orderList) {
            contactAccountPositionId
            contactId
            accountId
            userId
            location
            title
            startDate
            endDate
            current
            lastConfirmedAt
            positionDescription
            createdAt
            updatedAt
            deleted
            deletedAt
            account {
                accountId
                accountName
                accountLinkedinId
            }
        }
    }
`;

export const CREATE_CONTACT_ACCOUNT_POSITION = gql`
    mutation CreateContactAccountPosition($newContactAccountPosition: newContactAccountPosition!) {
        createContactAccountPosition(
            newContactAccountPosition: $newContactAccountPosition
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_CONTACT_ACCOUNT_POSITION = gql`
    mutation UpdateContactAccountPosition($changedContactAccountPosition: changedContactAccountPosition!) {
        updateContactAccountPosition(
            changedContactAccountPosition: $changedContactAccountPosition
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_CONTACT_ACCOUNT_POSITION = gql`
    mutation DeleteContactAccountPosition($deleteContactAccountPositionId: ID!) {
        deleteContactAccountPosition(
            deleteContactAccountPositionId: $deleteContactAccountPositionId
        ) {
            returnCode
            message
        }
    }
`;
